import React from 'react';

import ContactButton from './ContactButton/ContactButton';
import phoneNumberBlack from '../../assets/image/phone_number_black.svg';

const Contact = props => {
  if (props.invisible) { return null };

  const onClick = () => {
    const contactURL = 'https://asagaotv.jp/inquiry-form/';
    window.open(contactURL, '_blank')
  }


  return (
    <div className="ContactContainer">
      <div className="ContactTitle">
        お手数ですが、集合住宅の方は<br/>下記まで料金をお問い合わせください。
      </div>
      <div className="Contact">
        <div className="ContactCall">
          <div className="ContactFormTitle">
            お電話でお問い合わせ
          </div>
          <img src={phoneNumberBlack} className="PhoneNumber Black" alt="phoneNumberBlack" />
          <div className="PhoneNumberInfo" >
            AM9:00~18:00 [年中無休]
          </div>
        </div>
        <div className="ContactForm">
          <div className="ContactFormTitle">
            お問い合わせフォーム
          </div>
          <ContactButton onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
